// Schema.org Person / ItemList JSON-LD for the /our-team page.
//
// Mirrors the SOLS Energy pattern (lib/schema/person.ts): each team member is a
// Person whose `worksFor` links to the homepage Organization @id, wrapped in an
// ItemList. Foundation team members come from the SOLS Group CMS `publicTeam`
// node via getCmsTeam().

import type { TeamMember } from "../interfaces";

const SITE_URL = "https://sols.foundation";
const ORGANIZATION_ID = `${SITE_URL}/#organization`;

const personSchema = (member: TeamMember) => ({
  "@type": "Person",
  "@id": `${SITE_URL}/our-team#${member.slug}`,
  name: member.cardTitle,
  ...(member.cardSubtitle ? { jobTitle: member.cardSubtitle } : {}),
  ...(member.cardImage ? { image: member.cardImage } : {}),
  worksFor: { "@id": ORGANIZATION_ID },
});

export const buildTeamItemListSchema = (members: TeamMember[]) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  "@id": `${SITE_URL}/our-team#itemlist`,
  itemListElement: members
    .filter((m) => m && m.cardTitle)
    .map((member, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item: personSchema(member),
    })),
});
